import { Row, Col } from "@folio/stripes/components";
import React from "react";
import { useIntl } from "react-intl";
export var InfoAccordionContent = function (_a) {
    var companyNumber = _a.companyNumber;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement("div", { style: { marginBottom: "5px" } },
                React.createElement("strong", { style: { fontSize: "1.1em", paddingRight: "5px" } }, formatMessage({
                    id: "ui-br-users.organization.field.label.companyNumber",
                }))),
            React.createElement("div", null, companyNumber || "N/A"))));
};
